import styled from 'styled-components';
import {Select, Space} from 'antd';
import Search from '../../../../../Search';

const StyledTableFilters = styled(Space)`
  align-items: center;
  display: flex;
  justify-content: space-between;
  overflow-x: auto;

  .ant-btn {

    .ant-wave {
      display: none !important;
    }

    &.ant-btn-primary {
      .ant-btn-icon {
        svg {
          height: 16px;
          width: 16px;
          path {
            stroke: ${props => props.theme.colors.primary_1};
          }
        }
      }
    }
  }
`;

const StyledTableFiltersSelect = styled(Select)`
  min-width: 170px;

  &.ant-select-lg {
    .ant-select-selector {
      min-height: 40px;
      &::after {
        line-height: 30px;
      }
    }
  }
`;

const StyledTableFiltersSearch = styled(Search)`
  max-width: 180px;
  min-width: 130px;
  min-height: 40px;
  width: 100%;
`;

export {
  StyledTableFilters,
  StyledTableFiltersSelect,
  StyledTableFiltersSearch
};
